import { render, staticRenderFns } from "./RuleListCreate.vue?vue&type=template&id=4193df3d"
import script from "./RuleListCreate.vue?vue&type=script&lang=js"
export * from "./RuleListCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports